import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { Injectable, Optional } from '@angular/core';
import { OAuthModuleConfig } from 'angular-oauth2-oidc';
import { BehaviorSubject, defer, EMPTY, Subject, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AuthenticationService } from '../services/authenticationService';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthenticationService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isAuthenticated = this.authService.isAuthenticated();

    if (isAuthenticated) return next.handle(this.injectToken(request));

    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401 && !request.url.includes('CreateToken')) {
          this.authService.logout(false);
        }
      }

      return throwError(error);
    }));
  }

  private injectToken(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.authService.getAccessToken()}`
      }
    });
  }
}